import React, { useEffect, useState } from "react";
import { getEcdReportCardPdf, getReportCardPdf } from "../../../../../../../../services/reportCard";
import { REPORT_CARD_ERROR } from "../../../../../../../../constants/common";
import { toast } from "react-toastify";
import { Spin, Typography } from "antd";
import PDFViewer from "../../../../../../../../components/pdf-viewer/pdf-viewer";
import CustomButton from "../../../../../../../../common/custom-button/custom-button";
import { PrinterOutlined, DownloadOutlined } from "@ant-design/icons";
import styles from "./student-exam-report.module.css";
import { downloadS3File } from "../../../../../../../../utils/common";

const StudentExamReport = ({
  selectedExam,
  studentID,
  selectedYear,
  isEcdStudent,
  selectedTerm,
}) => {
  const [examReport, setExamReport] = useState(null);
  const [loading, setLoading] = useState(false);
  const [reportError, setReportError] = useState("");

  useEffect(() => {
    setExamReport(null);
    setReportError("");
    getExamReport();
  }, [selectedExam?.id, selectedTerm]);

  const getExamReport = async () => {
    setLoading(true);
    try {
      const params = {
        student_id: studentID,
        academic_year_id: selectedYear,
      };
      let response;
      if (isEcdStudent) {
        params.term_id = selectedTerm;
        response = await getEcdReportCardPdf(params);
      } else {
        params.exam_id = selectedExam?.id;
        response = await getReportCardPdf(params);
      }
      if (response?.data) {
        setExamReport(response?.data?.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (REPORT_CARD_ERROR.includes(error?.data?.message)) {
        setReportError(error?.data?.message);
      } else {
        setReportError("No Report card found");
        toast.error(error?.data?.message || "Something went wrong");
      }
      console.error(error?.data?.message || error?.message);
    }
  };

  const handlePrint = (url) => {
    if (!url) return;
    window.open(url, "_blank", "width=800,height=600");
  };

  if (loading) return <Spin spinning={loading} />;
  else if (reportError) {
    return <h2>{reportError}</h2>;
  }

  return (
    <div className={styles["exam-report-card-container"]}>
      <div className={styles["exam-report-title-container"]}>
        <Typography className={styles["exam-report-title"]}>Report Card</Typography>
        <div className={styles["exam-download-print-btn"]}>
          <CustomButton
            variant="filled"
            icon={<PrinterOutlined />}
            type="primary"
            title="Print Report"
            onClick={() => handlePrint(examReport?.download_url)}
          />
          <CustomButton
            variant="filled"
            icon={<DownloadOutlined />}
            type="default"
            title="Download Report"
            onClick={() => downloadS3File(examReport?.download_url, "report-card.pdf")}
          />
        </div>
      </div>
      <PDFViewer url={examReport?.download_url} />
    </div>
  );
};

export default StudentExamReport;